import React, { useState, useEffect, useRef }  from 'react';
import PostRequest from 'components/common/PostRequest.jsx';
import QuoteBuilderNavSection from 'components/layout_and_quote_builder/quote_builder/QuoteBuilderNavSection.jsx';
import { shouldHideTitle } from 'components/layout_and_quote_builder/utils/navSectionUtils.js';

const SelectedList = ( { config, selectedList, setSelectedList, index, totalNavSectionSize} ) => {
  const [navSections, setNavSections] = useState( [] );
  const [payload, setPayload] = useState( {});
  const [presentedOptions, setPresentedOptions] = useState( {});
  const [navSectionsVersion, setNavSectionsVersion] = useState(0);

  // Track the last fetched selectedList to prevent duplicate API calls
  const lastFetchedListRef = useRef(null);

  const fetchNavSections = () => {
    if(selectedList.length == 0) {
      setNavSections( () => [] )
      lastFetchedListRef.current = null;
      return;
    }

    // Deep compare to avoid duplicate fetches when content is the same
    const currentListJson = JSON.stringify(selectedList);
    if (lastFetchedListRef.current === currentListJson) {
      return;
    }
    lastFetchedListRef.current = currentListJson;

    PostRequest({
      url: `/layouts-nav-section-combination-select-lists`,
      data: {
        index: index,
        user_quote_id: window.user_quote_id,
        id: window.drawingId,
        formula_options: window.dielineOptions,
        lists: selectedList,
      },
      callback: (data) => {
        setNavSections( () => data.nav_sections )
        setPayload( () => data.payload )
        setPresentedOptions( () => data.presented_options )

        // Update window.nav_sections for other components to access
        window.user_quote_nav_sections = data.window_nav_sections;

        // Emit event to notify linked sections about updated nav sections
        window.dispatchEvent(new CustomEvent('navSectionsUpdated', {
          detail: { windowNavSections: data.window_nav_sections, sourceIndex: index }
        }));

        // Increment version to force remount of child components
        setNavSectionsVersion(previous => previous + 1);
      }
    })
  }

  // useEffect starts
  useEffect(fetchNavSections, [selectedList] )
  // useEffect ends

  return (
    <div>
      {navSections.map((navSection, _index) => {

        if(navSection.part_type == 'general') {

          emitEvent('nav_section_general_part_type', {
            _index: _index,
            index: index,
            config: config,
            payload: payload,
            presentedOptions: presentedOptions,
            navSection: navSection
          })

          return
        }

        return (
          <div className="row" key={`row_${_index}_v${navSectionsVersion}`}>
            <QuoteBuilderNavSection
              noTitle={shouldHideTitle(totalNavSectionSize)}
              index={index}
              config={config}
              payload={payload}
              presentedOptions={{presentedOptions}}
              key={`navSection_${_index}_${navSection.label}_v${navSectionsVersion}`}
              navSection={navSection}
              selectedList={selectedList}
              setSelectedList={setSelectedList}
            />
          </div>
        )
      })}

    </div>
  )
}

export default SelectedList;
